"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
function Modal(_a) {
    var children = _a.children, isOpen = _a.isOpen, close = _a.close, onResize = _a.onResize;
    var _b = (0, react_1.useState)(0), height = _b[0], setHeight = _b[1];
    var getModalHeight = function () {
        var elementList = document.getElementsByClassName('modal-inner');
        return elementList && elementList.length && elementList[0].clientHeight;
    };
    (0, react_1.useEffect)(function () {
        var callback = function () { setHeight(getModalHeight()); };
        window.addEventListener('resize', callback);
        return function () {
            window.removeEventListener('resize', callback);
        };
    }, []);
    (0, react_1.useEffect)(function () {
        onResize === null || onResize === void 0 ? void 0 : onResize(height);
    }, [height]);
    (0, react_1.useEffect)(function () {
        var callback = function (e) {
            e.key === 'Escape' && close();
        };
        window.addEventListener('keydown', callback);
        return function () {
            window.removeEventListener('keydown', callback);
        };
    }, [isOpen]);
    var onClickOutsideClose = function (e) {
        if ('target' in e &&
            e.target &&
            typeof e.target === 'object' &&
            'className' in e.target &&
            e.target.className == 'modal') {
            close();
        }
    };
    if (!isOpen)
        return;
    setTimeout(function () {
        setHeight(getModalHeight());
    }, 10);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: "modal", onClick: onClickOutsideClose, children: (0, jsx_runtime_1.jsx)("div", { className: "modal-inner", children: children }) }) }));
}
exports.default = Modal;
